import * as LabelPrimitive from '@radix-ui/react-label';
import * as React from 'react';

import { cn } from '@/lib/utils/cn';

const Label = React.forwardRef(
  (
    {
      className,
      disabled,
      ...props
    }: React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & {
      disabled?: boolean;
    },
    ref: React.ForwardedRef<React.ElementRef<typeof LabelPrimitive.Root>>
  ) => (
    <LabelPrimitive.Root
      ref={ref}
      className={cn('text-sm text-text leading-none', disabled && 'text-disableText', className)}
      {...props}
    />
  )
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
